import React from "react"
import { useStats } from "react-instantsearch"

const connectStats = Component => {
  const Stats = props => {
    const data = useStats()

    return <Component {...props} {...data} />
  }

  return Stats
}

const MyStats = ({ resultsText, currentRefinement, nbHits }) => {
  return (
    <h2 className="product-finder__stats">
      <span className="product-finder__stats__text">
        {resultsText
          ?.replace("{x}", nbHits)
          ?.replace("{query}", currentRefinement)}
      </span>
    </h2>
  )
}

const CustomStats = connectStats(MyStats)

export default CustomStats
